import React from "react";
import {Button} from 'semantic-ui-react';
import useApiHouse from "../../../api/useApiHouse";
import useFileReconJob from "../../../hooks/fileReconJobFile";
import useGetFormData from "../../../hooks/useGetFormData";

const FileReconBtn = ({filingState,setFilingState}) => {
    const {fileReconJob} = useFileReconJob();
    const fileOnClickHandler = () => {
        setFilingState("FILING");
        fileReconJob(setFilingState);
    }
    return ( 
        <Button compact className="recon-button" disabled={filingState} content={filingState ||"FILE"} onClick={fileOnClickHandler} />
     );
}
 
export default FileReconBtn;